module.exports = __webpack_public_path__ + "img/PopUpBanner_AM_Memorial_2024.84ade64d.jpg";